var header = document.querySelector('.sf-header__mobile');
var desktopLogo = document.querySelector('.desktop_logo');
    
if (header && desktopLogo) {
  var headerTop = header.getBoundingClientRect().top;
  var screenWidth = window.innerWidth;
      
  if (screenWidth === 1023 && headerTop === 0) {
    desktopLogo.style.setProperty('display', 'none', 'important');
  } else {
    desktopLogo.style.setProperty('display', 'block', 'important');
  }
}